
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMessageGoogle as ObiMessageGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-message-google.js';
 
 
 

 
 export const ObiMessageGoogle = createComponent({
   react: React,
   tagName: 'obi-message-google',
   elementClass: ObiMessageGoogleElement,
   events: {
     
   }
  });
 
 